import Router from 'next/router';
import { DEFAULT_FILTERS_PAGE_URL, PUBLIC_URL_PATH_LIST, TENANT_ID_NOT_REQUIRED_PATH_LIST } from '../constants/appUrls';
import { roles } from '../model/types';

export const isEmailVerificationPage: (url: string) => boolean = (url) => url.startsWith('/email-verification/');
export const isRegisterPage: (url: string) => boolean = (url) => url.startsWith('/register');
export const isNewTicketPage: (url: string) => boolean = (url) => url.startsWith('/tickets/new');
export const isTicketsPage: (url: string) => boolean = (url) => url.startsWith('/tickets');
export const isCustomerPage: (url: string) => boolean = (url) => url.startsWith('/users/');
export const isOrganizationPage: (url: string) => boolean = (url) => url.startsWith('/organizations/');
export const isPagePluginPage: (url: string) => boolean = (url) => url.startsWith('/plugins/');
export const isAdminTicketFieldsPage: (url: string) => boolean = (url) => url.startsWith('/admin/ticket-fields');
export const isAdminUserFieldsPage: (url: string) => boolean = (url) => url.startsWith('/admin/user-fields');
export const isAdminOrganizationFieldsPage: (url: string) => boolean = (url) =>
    url.startsWith('/admin/organization-fields');
export const isAdminOptionSortPage: (url: string) => boolean = (url) => url.endsWith('/sort');

export const isInternalLink = (url: string): boolean =>
    url.includes(process.env.NEXT_PUBLIC_HOSTNAME_WITHOUT_SUBDOMAIN);

export const getUsersPageUserRedirectUrlString: (userId: string | number, role: roles) => string = (userId, role) => {
    if (!role || !userId) return DEFAULT_FILTERS_PAGE_URL;
    if (role === 'ROLE_END_USER') return `/users/${userId}/tickets/requested?page=1&size=5`;
    return `/users/${userId}/tickets/assigned?page=1&size=5`;
};
export const getTicketsPageUserRedirectUrlString: (ticketKey: string | number, role: roles) => string = (
    ticketKey,
    role
) => {
    if (!role || !ticketKey) return DEFAULT_FILTERS_PAGE_URL;
    if (role === 'ROLE_END_USER') return `/tickets/${ticketKey}/requester/tickets/requested?page=1&size=5`;
    return `/tickets/${ticketKey}/requester/tickets/assigned?page=1&size=5`;
};

export const pushTo = (url: string) => Router.push(url);
export const redirectTo = (url: string) => Router.replace(url);

function isPublicPage(url: string): boolean {
    if (!url) return false;
    return PUBLIC_URL_PATH_LIST.some((urlPath) => url.startsWith(urlPath));
}
function isTenantIdRequiredPage(url: string): boolean {
    if (!url) return false;
    return !TENANT_ID_NOT_REQUIRED_PATH_LIST.some((urlPath) => url === urlPath);
}

export { isPublicPage, isTenantIdRequiredPage };
